import { render, staticRenderFns } from "./UsageStats.vue?vue&type=template&id=b8fa8ce2&scoped=true"
import script from "./UsageStats.vue?vue&type=script&lang=js"
export * from "./UsageStats.vue?vue&type=script&lang=js"
import style0 from "./UsageStats.vue?vue&type=style&index=0&id=b8fa8ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8fa8ce2",
  null
  
)

export default component.exports